import style from './../Report.module.scss';
import {FaSitemap} from 'react-icons/fa';
import moment from 'moment';
import ReportTypeStructure from '../ReportTypeStructure';
import ApplicatorsTable from './ApplicatorsTable/ApplicatorsTable';
import _ from 'lodash';

const ApplicatorsReport = ({report, isStandalone}) => {
    const {data} = report;
    const {distributor, clinic, applicators} = data;

    const getMostUsedApplicator = () => {
        return applicators.sort(function(a, b) {
            return b.pulses - a.pulses;
        })[0];
    }
    
    const getHeader = () => {
        return (
            <div className='d-flex'>
                <div>
                    <h1>{clinic ? <>{clinic.name}: Applicators Report</> : <>{distributor.name}: Distributor Applicators Report</>}</h1>
                    <label className={style.reportType}>{moment(report.filters.date_range.startDate).format('ll')} - {moment(report.filters.date_range.endDate).format('ll')}</label>
                </div>
            </div>
        )
    }

    const getContent = () => {
        return (
            <>
                <section>
                    <div className={style.cardRow}>
                        <div className={[style.card, style.cardFluid, style.col3].join(' ')}>
                            <h3>{applicators.length}</h3>
                            <label>Total Applicators</label>
                        </div>
                        <div className={[style.card, style.cardFluid, style.col3].join(' ')}>
                            <h3>{_.sumBy(applicators, 'pulses').toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}</h3>
                            <label>Total Pulses</label>
                        </div>
                        <div className={[style.card, style.cardFluid, style.col3].join(' ')}>
                        <h3>{getMostUsedApplicator() ? getMostUsedApplicator().name : 'N/A'}</h3>
                            <label>Most Used Applicator</label>
                        </div>
                    </div>
                </section>
                <section>
                    <h5>Applicators Overview</h5>
                    <div className={style.cardRow}>
                        <div className={[style.col6].join(' ')} style={{minHeight: 300}}>
                            <ApplicatorsTable isStandalone={isStandalone} applicators={applicators} />
                        </div>
                    </div>
                </section>
            </>
        )
    }
    return (
        <ReportTypeStructure isStandalone={isStandalone} report={report} header={getHeader()} content={getContent()} />
    )
}

export default ApplicatorsReport;